// extracted by mini-css-extract-plugin
export default {"deleteButton":"du_oc"};